import {
  PurchaseTermNames,
  LeaseTermNames,
  LeaseMileageNames,
  FinanceType,
} from '@upstart/harmony/lib/legos/constants';

export const MAX_LEASE_MILEAGES = 5;
export const MAX_LEASE_TERMS = 5;

export const ORDERED_PURCHASE_TERMS = [
  PurchaseTermNames.TERM1,
  PurchaseTermNames.TERM2,
  PurchaseTermNames.TERM3,
];

export const ORDERED_PURCHASE_TERM_TO_LABEL = {
  [PurchaseTermNames.TERM1]: 'Term 1',
  [PurchaseTermNames.TERM2]: 'Term 2',
  [PurchaseTermNames.TERM3]: 'Term 3',
};

export const ORDERED_LEASE_TERMS = [
  LeaseTermNames.TERM1,
  LeaseTermNames.TERM2,
  LeaseTermNames.TERM3,
  LeaseTermNames.TERM4,
  LeaseTermNames.TERM5,
];

export const ORDERED_LEASE_TERM_TO_LABEL = {
  [LeaseTermNames.TERM1]: 'Term 1',
  [LeaseTermNames.TERM2]: 'Term 2',
  [LeaseTermNames.TERM3]: 'Term 3',
  [LeaseTermNames.TERM4]: 'Term 4',
  [LeaseTermNames.TERM5]: 'Term 5',
};

export const CREDIT_RATING_MAX = 850;
export const CREDIT_RATING_MIN = 1;

export const FINANCE_TYPE_TO_LABEL = {
  [FinanceType.PURCHASE]: 'Purchase',
  [FinanceType.LEASE]: 'Lease',
  [FinanceType.CASH]: 'Cash',
};

export const ORDERED_MILEAGES = [
  LeaseMileageNames.MILEAGE1,
  LeaseMileageNames.MILEAGE2,
  LeaseMileageNames.MILEAGE3,
  LeaseMileageNames.MILEAGE4,
  LeaseMileageNames.MILEAGE5,
];

export const REQUIRED_MILEAGES = [
  LeaseMileageNames.MILEAGE1,
  LeaseMileageNames.MILEAGE2,
  LeaseMileageNames.MILEAGE3,
];

export const ORDERED_MILEAGE_TO_LABEL = {
  [LeaseMileageNames.MILEAGE1]: 'Mileage 1',
  [LeaseMileageNames.MILEAGE2]: 'Mileage 2',
  [LeaseMileageNames.MILEAGE3]: 'Mileage 3',
  [LeaseMileageNames.MILEAGE4]: 'Mileage 4',
  [LeaseMileageNames.MILEAGE5]: 'Mileage 5',
};

export const LEASE_TERM_TO_LABEL = {
  [LeaseTermNames.TERM1]: 'Term 1',
  [LeaseTermNames.TERM2]: 'Term 2',
  [LeaseTermNames.TERM3]: 'Term 3',
  [LeaseTermNames.TERM4]: 'Term 4',
  [LeaseTermNames.TERM5]: 'Term 5',
};

export enum TierKeyNames {
  TIER1 = 'tier1',
  TIER2 = 'tier2',
  TIER3 = 'tier3',
  TIER4 = 'tier4',
  TIER5 = 'tier5',
  TIER6 = 'tier6',
  TIER7 = 'tier7',
  TIER8 = 'tier8',
  TIER9 = 'tier9',
}

export const TIER_KEY_TO_LABEL = {
  [TierKeyNames.TIER1]: 'Tier1',
  [TierKeyNames.TIER2]: 'Tier2',
  [TierKeyNames.TIER3]: 'Tier3',
  [TierKeyNames.TIER4]: 'Tier4',
  [TierKeyNames.TIER5]: 'Tier5',
  [TierKeyNames.TIER6]: 'Tier6',
  [TierKeyNames.TIER7]: 'Tier7',
  [TierKeyNames.TIER8]: 'Tier8',
  [TierKeyNames.TIER9]: 'Tier9',
};

export const ORDERED_TIERS: TierKeyNames[] = [
  TierKeyNames.TIER1,
  TierKeyNames.TIER2,
  TierKeyNames.TIER3,
  TierKeyNames.TIER4,
  TierKeyNames.TIER5,
  TierKeyNames.TIER6,
  TierKeyNames.TIER7,
  TierKeyNames.TIER8,
  TierKeyNames.TIER9,
];

export const TIERS_MAX_LENGTH = 9;
export const TIERS_MIN_LENGTH = 4;
